import { Box, Card, Flex, Heading, Stack, useDisclosure } from '@chakra-ui/react';
import React, { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify';
import { baseUrl } from '../../utils/utils';
import CustomButton from '../../components/CustomButton';
import { BiArrowBack } from 'react-icons/bi';
import Loader from '../../components/Loader';
import DisplayData from '../../components/DisplayData';

const BankDetails = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [bankData, setBankData] = useState(null);
    const [loading, setIsLoading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    
    console.log("ID from params:", id);
    const fetchBankDetails = useCallback(async () => {
        if (!id) {
            console.log("No ID provided");
            return;
        }
    
        try {
          setIsLoading(true);
          console.log("Fetching bank details for ID:", id);
          
          const formData = new FormData();
          formData.append("action", "bank_details");
          formData.append("id", id);
    
          const response = await fetch(baseUrl + "bank.php", {
            method: "POST",
            body: formData,
          });
    
          console.log("Response status:", response.status, response.statusText);
    
          if (!response.ok) {
            throw new Error(`Failed to fetch bank details: ${response.statusText}`);
          }
    
          const result = await response.json();
          console.log("API Response:", result);
    
          // Handle the response based on your API structure
          if (result.success === true) {
            console.log("Setting bank data:", result.data);
            setBankData(result.data);
          } else if (result.status === "success") {
            console.log("Setting bank data (alt structure):", result.data);
            setBankData(result.data);
          } else {
            console.error("API returned error:", result.message);
            toast.error(result.message || "Failed to fetch bank data");
            // Don't navigate away, let user stay and retry
          }
        } catch (error) {
          console.error("Error fetching bank details:", error);
          toast.error("Failed to load bank data: " + error.message);
          // Don't navigate away automatically, let user decide
        } finally {
          setIsLoading(false);
        }
      }, [id]);

      useEffect(() => {
        fetchBankDetails();
      }, [fetchBankDetails]);

      console.log("Current bankData state:", bankData);

  return (
    <div>
       <Card
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        justify={"space-between"}
        paddingInline={5}
        paddingBlock={2}
        mb={4}
      >
        <Heading fontSize={"xl"}>Bank Details</Heading>
        <Flex alignItems={"center"} gap={3}>
          <CustomButton
            icon={<BiArrowBack color="#fff" />}
            title={"Back"}
            height={"30px"}
            b_color={"#000"}
            onClick={() => navigate(-1)}
          />
        </Flex>
      </Card>
      
      {loading ? (
        <Card p={5} justify={"center"} alignItems={"center"}>
          <Loader />
        </Card>
      ) : bankData ? (
        <Stack>
          <Card paddingInline={5} paddingBlock={2}>
            <DisplayData
              title={"Bank Name"}
              v_color={"#f37022"}
              fw={"bold"}
              value={bankData.bankname || "NA"}
            />
            <DisplayData
              title={"Bank Branch"}
              value={bankData.bank_branch || "NA"}
              fs={"16px"}
              v_color={"#169e49"}
              fw={"bold"}
            />
            <DisplayData 
              title={"Account Type"} 
              value={bankData.ac_type || "NA"} 
            />
            <DisplayData 
              title={"Account Number"} 
              value={bankData.accountno || "NA"} 
            />
            <DisplayData
              title={"IFSC Code"}
              value={bankData.ifsc || "NA"}
            />
            <DisplayData 
              title={"Opening Balance"} 
              value={bankData.acc_ob || "NA"} 
            />
            <DisplayData 
              title={"Closing Balance"} 
              value={bankData.acc_cb || "NA"} 
            />
            <DisplayData 
              title={"Status"} 
              value={bankData.status === "0" ? "Inactive" : "Active"} 
            />
            <DisplayData 
              title={"Created Date"} 
              value={bankData.created_date || "NA"} 
            />
          </Card>
          
          {/* QR Code Image Section */}
          {bankData.qr_code && (
            <Card paddingInline={5} paddingBlock={4} mt={4}>
              <Heading fontSize={"lg"} mb={3} color="#f37022">
                QR Code Image
              </Heading>
              <Flex justify="center" align="center">
                <img 
                  src={bankData?.qr_code} 
                  alt="QR Code"
                  style={{
                    maxWidth: '300px',
                    maxHeight: '300px',
                    width: 'auto',
                    height: 'auto',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <Box 
                  display="none" 
                  color="gray.500" 
                  textAlign="center"
                  p={4}
                  border="2px dashed #e2e8f0"
                  borderRadius="8px"
                >
                  QR Code image not available
                </Box>
              </Flex>
            </Card>
          )}
        </Stack>
      ) : (
        <Card p={5} justify={"center"} alignItems={"center"}>
          <Heading size="md" color="gray.500">
            No bank data found
          </Heading>
          <CustomButton
            title="Retry"
            onClick={fetchBankDetails}
            mt={3}
          />
        </Card>
      )}
    </div>
  )
}

export default BankDetails